import React from "react";

import { icons, colors } from "oolib";

import styled, { css } from "styled-components";
import { transition } from "oolib/dist/themes/mixins";
const { Plus } = icons;

const commonStyles = css`
  background-color: ${colors.greyColor5};
  border: none;
  ${transition("background-color")}
  &:hover {
    background-color: ${colors.greyColor10};
  }
  cursor: pointer;
`;

const StyledRowButton = styled.button`
  height: 2rem;
  text-align: center;
  width: 100%;
  ${commonStyles}
`;

const StyledColButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${commonStyles}
`;

export const AddRowButton = ({ onClick }) => {
  return (
    <StyledRowButton onClick={onClick}>
      <Plus size={12} weight={"bold"} />
    </StyledRowButton>
  );
};

export const AddColButton = ({ onClick, addColButtonWidth, enableRowActions }) => {
  return (
    <StyledColButton 
      style={{
        width: addColButtonWidth+'px',
        ...(enableRowActions ? {marginBottom: '2rem'} : {}) //should be same as height of StyledRowButton
      }} 
      onClick={onClick}
      >
      <Plus size={12} weight={"bold"} />
    </StyledColButton>
  );
};
